import * as React from "react";

import primaryColour from "../../constants";

function SvgClose(props: React.SVGProps<SVGSVGElement>): React.ReactElement {
  const { fill = primaryColour } = props;
  return (
    <svg width={18} height={17} viewBox="0 0 18 17" fill="none" {...props}>
      <path
        d="M16.785 15.222C17.1206 15.5664 17.1206 16.1247 16.785 16.469C16.4494 16.8134 15.9053 16.8134 15.5697 16.469L0.985832 1.50524C0.65023 1.1609 0.65023 0.602602 0.985832 0.258258C1.32143 -0.086086 1.86555 -0.0860861 2.20115 0.258258L16.785 15.222Z"
        fill={fill}
      />
      <path
        d="M15.5698 0.25827C15.9054 -0.0860751 16.4495 -0.0860749 16.7851 0.25827C17.1207 0.602615 17.1207 1.16091 16.7851 1.50525L2.20128 16.469C1.86568 16.8134 1.32156 16.8134 0.985958 16.469C0.650356 16.1247 0.650356 15.5664 0.985958 15.222L15.5698 0.25827Z"
        fill={fill}
      />
    </svg>
  );
}

export default SvgClose;
